export const USER_LOGIN_SUCCESS = '@User_LoginSuccess';
export const USER_LOGIN_ERROR = '@User_LoginError';
export const USER_LOGOUT = '@User_Logout';



// WEBPACK FOOTER //
// ./src/app/stores/reducers/user/ActionsUser.ts